import { type Ref, forwardRef, type JSX } from 'react';
import classNames from 'classnames';
import { ColorBadge } from '../../types';
import styles from './styles/styles.module.scss';
import { formatBadgeNumber } from './utils';

export type CounterBadgeProps = {
  className?: string;
  color?: ColorBadge;
  round?: boolean;
  testId?: string;
  title?: string;
  limit?: number;
  count?: number;
  text?: string;
};

const CounterBadge = (
  { className, color = 'default', round, testId, title, limit, count, text }: CounterBadgeProps,
  ref: Ref<HTMLElement>
): JSX.Element => {
  const classes = classNames(styles.span, styles[color], className);

  return (
    <span className={classes} data-testid={testId} title={title || text || count?.toString() || ''} ref={ref as Ref<HTMLSpanElement>}>
      {text ? text : count && formatBadgeNumber(count, limit, round)}
    </span>
  );
};

export default forwardRef(CounterBadge);
